export default {
  getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  },

  getTokenFromCookie(name) {
    const cookie = this.getCookie(name);
    if (!cookie) return;

    const token = cookie.substr(cookie.indexOf("=") + 1);
    if (!token) return;

    return token.substr(0, token.indexOf("&"));
  },

  removeCookie(name) {
    document.cookie =
      name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;";
  },
};
